let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gMPge")).then(() => parcelRequire('bTBlN'));